import { useEffect, useState } from 'react';
import PrivateHofWorkspace from './PrivateHofWorkspace';

type Context = {
  ownerUserId: string;
  capabilities: { planning: boolean; conversationLifecycle: boolean };
  closedCapabilities: string[];
  blocker?: { code: string; error: string; nextStep: string };
};

/** The private route never mounts the admin GuidePanel or its global event bus. */
export default function PrivateGuideStatus() {
  const [context, setContext] = useState<Context | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    void fetch('/api/guide/kontext', { signal: controller.signal }).then(async response => {
      if (!response.ok) throw new Error(`Privater Guide konnte nicht geladen werden (${response.status}).`);
      const data = await response.json() as Context;
      if (!data.ownerUserId || !data.capabilities || !Array.isArray(data.closedCapabilities) || (!data.capabilities.conversationLifecycle && !data.blocker?.code)) {
        throw new Error('Der Server hat keinen gültigen privaten Guide-Status geliefert.');
      }
      setContext(data);
    }).catch((reason: unknown) => {
      if (!controller.signal.aborted) setError(reason instanceof Error ? reason.message : String(reason));
    });
    return () => controller.abort();
  }, []);
  if (context?.capabilities.conversationLifecycle) return <PrivateHofWorkspace onClose={() => window.location.assign('/')} />;
  return <main className="private-guide-page">
    <h1>Dein privater Guide</h1>
    {error && <p role="alert">{error}</p>}
    {!context && !error && <p role="status">Dein Bereich wird geprüft …</p>}
    {context && !context.capabilities.conversationLifecycle && <>
      <p>Deine Projektverwaltung hat einen eigenen Speicherbereich. Der vollständige Guide ist noch nicht verfügbar.</p>
      <p role="status" data-ai-id="private-guide-closed-capabilities">Coach, Entscheidungsboards, Antworten und Weiterarbeit sind noch geschlossen. Ein Coach kann derzeit nicht sicher gestartet werden.</p>
      <details data-ai-id="private-guide-blocker-detail"><summary>Was noch fehlt</summary>
        <p>{context.blocker?.error}</p><p>{context.blocker?.nextStep}</p>
      </details>
    </>}
    <p><a href="/" data-ai-id="private-guide-back">Zurück zum Arbeitsbereich</a></p>
  </main>;
}
